import type { FeatureStyleNode } from '../feature-style.model';

// =============================================================================
// PARAMS - Feature configuration from widget config
// =============================================================================

/** Y-intercept feature parameters */
export interface YInterceptParams {
  /** Reference to parent function element */
  of: string;
}

// =============================================================================
// DEFAULTS
// =============================================================================

/** No additional defaults beyond `of` which must be provided */
export const Y_INTERCEPT_DEFAULT_PARAMS: Omit<YInterceptParams, 'of'> = {};

/**
 * Default theme for y-intercept feature.
 * Green colored point for y-intercept.
 */
export const Y_INTERCEPT_DEFAULTS: FeatureStyleNode = {
  point: { color: 'green', fixed: true },
};
